export default "__VITE_ASSET__BbaFKHun__"